import { render, staticRenderFns } from "./RegulationsLayout.vue?vue&type=template&id=b5ac86e6&scoped=true&"
import script from "./RegulationsLayout.vue?vue&type=script&lang=js&"
export * from "./RegulationsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsLayout.vue?vue&type=style&index=0&id=b5ac86e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac86e6",
  null
  
)

export default component.exports